import React,{useState,useEffect,useContext} from 'react'
import systemMasterServices from '../app/master/systemMasterServices';
import vendorServices from '../app/admin/erp/vendors/vendorServices';
import productServices from '../app/admin/erp/product/productServices';
import poTermsServices from '../app/admin/erp/po/poTermsServices';
import customerServices from '../app/admin/erp/customer/customerServices';
import projectServices from '../app/admin/erp/project/projectServices';
import userServices from '../app/admin/user/userServices';
import userRoleServices from '../app/admin/user/userRoleServices';
import projectLocationServices from '../app/admin/erp/project/projectLocationServices';
import companyServices from '../app/admin/erp/company/companyServices';
import transactionCategoryServices from '../app/admin/erp/transaction/transactionCategoryServices';
import transactionServices from '../app/admin/erp/transaction/transactionServices';
import employeeServices from '../app/admin/erp/employee/employeeServices';
import taskServices from '../app/admin/erp/tasks/taskServices';
import inventoryServices from '../app/admin/erp/inventory/inventoryServices';
import tenderServices from '../app/admin/erp/tender/tenderServices';
import calendarServices from '../app/admin/erp/calendar/calendarServices';


const AppDataContext = React.createContext();

export const useAppData = () => {
    return useContext(AppDataContext);
}

export const AppDataProvider = (props) =>{
    
    const [loading,setLoadingStatus] = useState(false)
    const [masters,setMasters] = useState(null);
    const [toolbarStatus,setToolbarStatus] = useState(false);

    const [eventList,setEventList] = useState();
    const [selectedEvent,setSelectedEvent] = useState(null);

    const [companyList,setCompanyList] = useState(null);
    const [companyDD,  setCompanyDD] = useState(null);

    const [tenderList,setTenderList] = useState(null);
    const [tenderDD,  setTenderDD] = useState(null)
    

    const [employeeList,setEmployeeList] = useState(null);
    const [employeeDD,  setEmployeeDD] = useState(null);
    
    const [vendorList,setVendorList] = useState(null);
    const [vendorDD,setVendorDD] = useState(null);
    const [productList,setProductList] = useState(null);
    const [productDD,setProductDD] = useState(null);
    
    const [inventoryTransactionList,setInventoryTransactionList] = useState(null);
    const [inventoryStockList,setInventoryStockList] = useState(null);

    const [customerList,setCustomerList] = useState(null);
    const [customerDD,setCustomerDD] = useState(null);
    
    const [projectList,setProjectList] = useState(null);
    const [projectDD, setProjectDD] = useState(null)
    const [projectLocationList,setProjectLocationList] = useState(null);
    const [projectLocationDD,setProjectLocationDD] = useState(null);

    const [taskList,setTaskList] = useState(null);
    const [taskDD, setTaskDD] = useState(null)

    const [transactionCategoryList,setTransactionCategoryList] = useState(null);
    const [transactionCategoryDD,setTransactionCategoryDD] = useState(null);

    const [transactionList,setTransactionList] = useState(null);

    const [userDD, setUserDD] = useState(null);
    const [userRoleDD, setUserRoleDD] = useState(null);

    const [poTermsList,setPOTermsList] = useState(null);
    
    const getMasterList = () => {
        systemMasterServices.get([
                "billing-type",
                "business-type",
                "department",
                "document-category",
                "document-status",
                "document-type",
                "employee-designation",
                "employee-type",
                "expense-type",
                "gender",
                "grievance-status",
                "grievance-type",
                "indian-state",
                "inventory-type",
                "leave-type",
                "po-status",
                "product-brand",
                "product-category",
                "product-uom",
                "task-status",
                'vendor-category',
                "tender-type",
                "transaction-method"
            ]).then(res=>{
            setMasters(res);
        }).catch(error=>{
        })
    }
    
    const getMasterLabel = (type, id) => {
        try{
            let label = masters[type].find(m => m.value === id)
            return label.label;
        } catch(e){
            //console.log(type,id);
            return "";
        }
    }


    const getCalendarEventList = () =>{
        calendarServices.getList().then(res=>{
            setEventList(res.data);
        }).catch(error=>{
            console.log(error);
        })
    }

    const getCompanyList = () =>{
        setLoadingStatus(true);
        companyServices.getList().then(res=>{
            setCompanyList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getCompanyDD = () =>{
        setLoadingStatus(true);
        companyServices.getDD().then(res=>{
            setCompanyDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }


    const getTenderList = () =>{
        setLoadingStatus(true);
        tenderServices.getList().then(res=>{
            setTenderList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getTenderDD = () =>{
        setLoadingStatus(true);
        tenderServices.getDD().then(res=>{
            setTenderDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getEmployeeList = () =>{
        setLoadingStatus(true);
        employeeServices.getList().then(res=>{
            setEmployeeList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getEmployeeDD = () =>{
        setLoadingStatus(true);
        employeeServices.getDD().then(res=>{
            setEmployeeDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getVendorList = () =>{
        setLoadingStatus(true);
        vendorServices.getList().then(res=>{
            setVendorList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getVendorDD = () =>{
        setLoadingStatus(true);
        vendorServices.getDD().then(res=>{
            setVendorDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getProductList = () =>{
        setLoadingStatus(true);
        productServices.getList().then(res=>{
            setProductList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
    const getProductDD = () =>{
        setLoadingStatus(true);
        productServices.getDD().then(res=>{
            setProductDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getInventoryTransactionList = () =>{
        setLoadingStatus(true);
        inventoryServices.getTransactionList().then(res=>{
            setInventoryTransactionList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }


    const getInventoryStockList = () =>{
        setLoadingStatus(true);
        inventoryServices.getStockList().then(res=>{
            setInventoryStockList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getCustomerList = () =>{
        setLoadingStatus(true);
        customerServices.getList().then(res=>{
            setCustomerList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getCustomerDD = () =>{
        setLoadingStatus(true);
        customerServices.getDD().then(res=>{
            setCustomerDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getProjectList = () =>{
        setLoadingStatus(true);
        projectServices.getList().then(res=>{
            setProjectList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getProjectDD = () =>{
        setLoadingStatus(true);
        projectServices.getDD().then(res=>{
            setProjectDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }



    const getTaskList = () =>{
        setLoadingStatus(true);
        taskServices.getList().then(res=>{
            setTaskList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getTaskDD = () =>{
        setLoadingStatus(true);
        taskServices.getDD().then(res=>{
            setTaskDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getProjectLocationList = () =>{
        setLoadingStatus(true);
        projectLocationServices.getList().then(res=>{
            setProjectLocationList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getProjectLocationDD = () =>{
        setLoadingStatus(true);
        projectLocationServices.getDD().then(res=>{
            setProjectLocationDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getTransactionCategoryList = () =>{
        setLoadingStatus(true);
        transactionCategoryServices.getList().then(res=>{
            setTransactionCategoryList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const getTransactionCategoryDD = () =>{
        setLoadingStatus(true);
         transactionCategoryServices.getDD().then(res=>{
            setTransactionCategoryDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }


     const getTransactionList = () =>{
        setLoadingStatus(true);
        transactionServices.getList().then(res=>{
            setTransactionList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }
        
    const getUserDD = () =>{
        setLoadingStatus(true);
        userServices.getDD().then(res=>{
            setUserDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }


    const getUserRoleDD = () =>{
        setLoadingStatus(true);
        userRoleServices.getDD().then(res=>{
            setUserRoleDD(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }


    const getPOTermsList = () =>{
        setLoadingStatus(true);
        poTermsServices.getList().then(res=>{
            setPOTermsList(res.data);
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }


    const getAppDataById = (dataArray,id) =>{
        try{
            let data =  dataArray?.find(d => d.id === id)
            return data;
        } catch(e){
            //console.log(type,id);
            return "";
        } 
    }

    const getDDDataById = (dataArray,value) =>{
        try{
            let data =  dataArray?.find(d => d.value === Number(value))
            return data;
        } catch(e){
            //console.log(type,id);
            return "";
        } 
    }
    
    

    const value= {
        eventList,getCalendarEventList,
        selectedEvent,setSelectedEvent,
        toolbarStatus,setToolbarStatus,
        masters,getMasterLabel,
        companyList,getCompanyList, companyDD,getCompanyDD,
        tenderList,getTenderList,tenderDD,getTenderDD,

        vendorList,getVendorList, vendorDD,getVendorDD,
        employeeList,getEmployeeList, employeeDD,getEmployeeDD,
        productList,getProductList, productDD,getProductDD,

        inventoryTransactionList,getInventoryTransactionList,
        inventoryStockList,getInventoryStockList,

        customerList,getCustomerList, customerDD,getCustomerDD,
        projectList,getProjectList, projectDD,getProjectDD,
        projectLocationList,getProjectLocationList,projectLocationDD,getProjectLocationDD,

        taskList,getTaskList,taskDD,getTaskDD,

        transactionCategoryList,getTransactionCategoryList,transactionCategoryDD,getTransactionCategoryDD,
        transactionList,getTransactionList,

        

        userDD,getUserDD,
        userRoleDD,getUserDD,
        poTermsList,getPOTermsList,
        getAppDataById, getDDDataById,
        loading
    }

    useEffect(()=>{
        getMasterList();
        getCompanyDD();
        getTenderDD();
        getProductDD();
        getEmployeeDD();
        getVendorDD();
        getCustomerDD();
        getProductDD()
        getProjectDD()
        getProjectLocationDD();
        getTransactionCategoryDD();
        getUserDD();
        getUserRoleDD();
        getPOTermsList();

        getCalendarEventList();
    },[])
    
    return (
        eventList && masters && productDD && vendorDD && customerDD && projectDD && userDD,userRoleDD && companyDD && employeeDD && transactionCategoryDD &&
        <AppDataContext.Provider value= {value}>{props.children}</AppDataContext.Provider>
    )
}